<template>
	<section class="flex justify-between space-x-4 lg:col-span-4">
		<div class="flex flex-wrap items-center">
			<span class="mr-4 text-2xl font-semibold capitalize">
				{{ fullName }}
			</span>
			<span class="text-sm text-mx-orange">
				{{ `#${accountId} ${formattedAddress}` }}
			</span>
		</div>
		<FormSelect
			v-model="viewableAccount"
			:options="accountOptions"
			:label="t('account-page.buttons.switch-account')"
			static-label
			option-width="max-w-80"
		/>
	</section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface AccountOption {
	id: string | number
	name: string
}

interface Props {
	accountOptions: AccountOption[]
	fullName?: string
	accountId?: string | number
	formattedAddress?: string
	modelValue?: {
		id: string
		name: string
	}
}
withDefaults(defineProps<Props>(), {
	accountOptions: () => [],
	fullName: '',
	accountId: '',
	formattedAddress: '',
})

const { t } = useI18n()

const viewableAccount = defineModel<{ id: string; name: string }>({
	default: () => ({ id: '', name: '' })
})
</script>
